import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { type IResponseContactActivecampaignIntegration } from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'

export class ContactActivecampaign extends ContactIntegrationBase<IResponseContactActivecampaignIntegration> {
  integration_type: 'activecampaign'

  constructor(response: IResponseContactActivecampaignIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = 'activecampaign'
    this.email = response.email
    this.national_number = response.phone
    this.phone = this.national_number
  }
}
